import { BrandCatalogueResponse } from '../services/schemas/getCatalogue';
import { Catalogue } from '../types/catalogue.type';

const applianceTileNameMap: Record<string, string> = {
  'Home Laundry': 'Laundry',
  Refrigeration: 'Refrigerators and freezers',
  Dishwashing: 'Dishwashers',
  'Cooking Equipment': 'Cooking',
  Microwave: 'Microwaves',
  'Small Domestic Appliances': 'Other appliances',
  Miscellaneous: 'Commercial appliances',
};

export const mapCatalogue = (catalogue: BrandCatalogueResponse[]): Catalogue[] => {
  return catalogue.map((item) => ({
    categoryName: applianceTileNameMap[item.categoryName] || item.categoryName,
    categoryCode: item.categoryCode,
    iconPath: `../../assets/icons/appliances/${item.categoryCode.toLowerCase()}.svg`,
    appliances: item.appliances,
  }));
};
